/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
import React, { useRef, useState } from 'react';
import { Modal, Button, Divider } from 'semantic-ui-react';
import { shape } from 'prop-types';
import { useDispatch } from 'react-redux';
import { createMemo } from 'Redux/modules/webChat/memo/actions';
import useProfile from 'Hooks/doctor/useDoctorProfile';
import { removeModal } from 'Redux/modules/modal/actions';
import { findClinicIdFromClinicsMapping } from 'Helpers/consult-utils';

import MemoRandumForm from './MemoRandumForm';

const MemoRandum = ({ id, data: { conversation } }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const ref = useRef();

  const { profile } = useProfile();

  const signatureFileId = profile?.signatureFileId;
  const {
    latestConsult: { id: consultId, forPatient },
  } = conversation;
  const { fullName, nric } = forPatient;

  const onClose = () => {
    dispatch(removeModal(id));
  };

  const create = () => {
    ref.current.submit();
  };

  const onSubmit = async values => {
    try {
      const body = {
        ...values,
        signFileId: signatureFileId,
      };
      setLoading(true);
      await dispatch(createMemo(consultId, body));
      onClose();
    } catch (err) {
      setError(err.data);
      setLoading(false);
    }
  };

  const initialValues = {
    patientName: fullName,
    patientNric: nric,
    content: '',
    subject: '',
    paymentType: 0,
    clinicId: findClinicIdFromClinicsMapping(
      conversation?.latestConsult?.clinics || [],
      profile.id,
    ),
  };

  return (
    <Modal
      open
      size="small"
      onClose={onClose}
      closeOnDimmerClick={false}
      closeIcon
      enableReinitialize>
      <Modal.Header>Create Memo</Modal.Header>
      <Modal.Content>
        <MemoRandumForm ref={ref} initialValues={initialValues} onSubmit={onSubmit} ena />
        {error && (
          <div className="error">
            <Divider hidden />
            <span>{error.message}</span>
          </div>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button content="Cancel" onClick={onClose} type="button" disabled={loading} />
        <Button
          content="Create"
          type="submit"
          primary
          onClick={create}
          loading={loading}
          disabled={loading}
        />
      </Modal.Actions>
    </Modal>
  );
};

MemoRandum.propTypes = {
  conversation: shape({}).isRequired,
};

export default MemoRandum;
